import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, Suspense as _Suspense, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-1a279a8d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "main" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "empty2 box" }, null, -1));
const _hoisted_3 = {
    key: 0,
    class: "overlay box"
};
const _hoisted_4 = {
    key: 1,
    class: "marke relative show_content"
};
const _hoisted_5 = {
    key: 2,
    class: "order"
};
const _hoisted_6 = {
    key: 4,
    class: "marke box relative"
};
const _hoisted_7 = {
    key: 5,
    class: "smart_phone_middle relative"
};
const _hoisted_8 = {
    key: 6,
    class: "smart_phone_under relative"
};
const _hoisted_9 = {
    key: 9,
    class: "balances box relative"
};
import ChartZone from '@/components/organisms/main/trade/ChartZone.vue';
import { useStore } from '@/store/store';
import { onMounted, ref, watch } from 'vue';
import Balances from '../organisms/main/trade/Balances.vue';
import CurrencyPair from '../organisms/main/trade/CurrencyPair.vue';
import History from '../organisms/main/trade/History.vue';
import MyOrder from '../organisms/main/trade/MyOrder.vue';
import Order from '../organisms/main/trade/Order.vue';
import OrderBook from '../organisms/main/trade/OrderBook.vue';
import SmartPhoneMiddle from '../organisms/main/trade/SmartPhoneMiddle.vue';
import SmartPhoneUnder from '../organisms/main/trade/SmartPhoneUnder.vue';
import QuickAccess from '../../materials/molecules/QuickAccess.vue';
import Loading from '../../materials/molecules/Loading.vue';
import { changeTheme } from '@/logics/theme';
import MarketInfo from '../organisms/main/trade/MarketInfo.vue';
import { useHistory } from '@/logics/history';
import { useRoute } from 'vue-router';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isAuth: { type: Boolean },
        userInfo: null
    },
    setup(__props) {
        const props = __props;
        const route = useRoute();
        const { getLatestValue } = useHistory();
        const store = useStore();
        const latestValue = ref(0);
        const param = route.query['c'];
        const paramsPair = param && param.split('_')[1] ? param.split('_') : null;
        const current = paramsPair ? store.state.currencyPairInfo.find((c) => c.pair === paramsPair[0] + paramsPair[1]) : null;
        if (current && paramsPair) {
            store.commit('setSymbol', {
                pair: paramsPair[0] + paramsPair[1],
                base: paramsPair[0],
                quote: paramsPair[1],
            });
        }
        if (store.getters.symbol === null && store.state.currencyPairInfo.length > 0) {
            // 通貨が未設定の場合は通貨ペア一覧の一番上を設定
            const symbol = store.state.currencyPairInfo.map((i) => {
                return { pair: i.pair, base: i.base, quote: i.quote };
            })[0];
            store.commit('setSymbol', symbol);
        }
        const symbol = store.getters.symbol;
        const pair = ref(symbol.pair);
        const base = ref(symbol.base);
        const quote = ref(symbol.quote);
        const changeLatest = () => {
            const current = store.state.currencyPairInfo.find((c) => c.pair === store.getters.symbol.pair);
            store.state.last24Value = Number((current === null || current === void 0 ? void 0 : current.last24Value) || 0);
        };
        watch(() => store.state.symbol.pair, () => {
            getLatestValue().then((value) => {
                latestValue.value = value;
            });
            pair.value = store.state.symbol.pair;
            base.value = store.state.symbol.base;
            quote.value = store.state.symbol.quote;
            changeLatest();
            store.state.order.price = 0;
            store.state.order.amount = 0;
        });
        onMounted(() => {
            if (store.getters.theme) {
                changeTheme(store.getters.theme);
            }
            else {
                store.commit('setTheme', 'Dark');
            }
            const symbol = store.getters.symbol;
            if (symbol) {
                pair.value = symbol.pair;
                base.value = symbol.base;
                quote.value = symbol.quote;
                getLatestValue().then((value) => {
                    latestValue.value = value;
                });
                changeLatest();
            }
        });
        const isShowCurrencyPair = ref(false);
        const showCurrencyPair = (isShow) => {
            isShowCurrencyPair.value = isShow;
        };
        const isShowOrder = ref(false);
        const orderType = ref('Buy');
        const orderModalType = (e) => {
            isShowOrder.value = !isShowOrder.value;
            orderType.value = e;
        };
        const showOrder = (isShow) => {
            isShowOrder.value = isShow;
        };
        const chartKey = ref(0);
        const reloadChart = () => {
            chartKey.value = chartKey.value === 0 ? 1 : 0;
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _hoisted_2,
                (isShowCurrencyPair.value || isShowOrder.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3))
                    : _createCommentVNode("", true),
                (_unref(store).state.isSmartPhone && isShowCurrencyPair.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(CurrencyPair, { onClick: showCurrencyPair })
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createVNode(QuickAccess, {
                            "is-auth": props.isAuth,
                            onClick: orderModalType
                        }, null, 8, ["is-auth"])
                    ]))
                    : _createCommentVNode("", true),
                (isShowOrder.value && _unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", {
                        class: "order show_order_content",
                        key: pair.value
                    }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(Order, {
                                    isAuth: props.isAuth,
                                    pair: pair.value,
                                    base: base.value,
                                    quote: quote.value,
                                    latestValue: latestValue.value,
                                    trade: orderType.value,
                                    onClick: showOrder
                                }, null, 8, ["isAuth", "pair", "base", "quote", "latestValue", "trade"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (_openBlock(), _createElementBlock("div", {
                    class: "infomation box relative",
                    key: pair.value
                }, [
                    _createVNode(MarketInfo, {
                        pair: pair.value,
                        base: base.value,
                        quote: quote.value,
                        onClick: showCurrencyPair
                    }, null, 8, ["pair", "base", "quote"])
                ])),
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(CurrencyPair)
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(SmartPhoneMiddle, {
                                    "is-auth": props.isAuth,
                                    pair: pair.value,
                                    base: base.value,
                                    quote: quote.value,
                                    "latest-value": latestValue.value
                                }, null, 8, ["is-auth", "pair", "base", "quote", "latest-value"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(SmartPhoneUnder, {
                                    "is-auth": props.isAuth,
                                    "user-info": props.userInfo,
                                    pair: pair.value,
                                    base: base.value,
                                    quote: quote.value
                                }, null, 8, ["is-auth", "user-info", "pair", "base", "quote"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", {
                        class: "order box",
                        key: pair.value
                    }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(Order, {
                                    isAuth: props.isAuth,
                                    pair: pair.value,
                                    base: base.value,
                                    quote: quote.value,
                                    latestValue: latestValue.value
                                }, null, 8, ["isAuth", "pair", "base", "quote", "latestValue"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["chart box", _unref(store).state.chart.isFull ? 'fullscreen' : 'relative']),
                        key: pair.value + chartKey.value
                    }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(ChartZone, {
                                    pair: pair.value,
                                    failedChart: reloadChart
                                }, null, 8, ["pair"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ], 2))
                    : _createCommentVNode("", true),
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(Balances, {
                                    isAuth: props.isAuth,
                                    userInfo: props.userInfo
                                }, null, 8, ["isAuth", "userInfo"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", {
                        class: "my_order box relative",
                        key: pair.value
                    }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(MyOrder, {
                                    isAuth: props.isAuth,
                                    userInfo: props.userInfo,
                                    pair: pair.value,
                                    base: base.value,
                                    quote: quote.value
                                }, null, 8, ["isAuth", "userInfo", "pair", "base", "quote"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", {
                        class: "order_book box relative",
                        key: pair.value
                    }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(OrderBook, {
                                    isAuth: props.isAuth,
                                    quote: quote.value,
                                    base: base.value,
                                    latestValue: latestValue.value
                                }, null, 8, ["isAuth", "quote", "base", "latestValue"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true),
                (!_unref(store).state.isSmartPhone)
                    ? (_openBlock(), _createElementBlock("div", {
                        class: "histo box relative",
                        key: pair.value
                    }, [
                        (_openBlock(), _createBlock(_Suspense, null, {
                            default: _withCtx(() => [
                                _createVNode(History, {
                                    isAuth: props.isAuth
                                }, null, 8, ["isAuth"])
                            ]),
                            fallback: _withCtx(() => [
                                _createVNode(Loading)
                            ]),
                            _: 1
                        }))
                    ]))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
